<div class="grid">
  <ng-template [ngIf]="isLoading">
    <app-loading></app-loading>
</ng-template>
  <div class="col-12 p-2 text-xl text-left font-['Poppins']"
    style="color: cadetblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <span class="text-xl text-left font-['Poppins'] mr-3" style="color: cadetblue;">Bando 1</span>
      <div class="p-2" style="border-radius: 10px; background-color: #619496; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #f9f9f9; font-size: small; cursor: pointer;"
              pTooltip="Apri tutti i prontofibra del BANDO 1" tooltipPosition="top"  (click)="openAllPF(1)"
        >Totali: <span class="font-semibold" style="font-size: medium;" >{{bando1}}</span></span>
      </div>
      <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;cursor: pointer;"
          pTooltip="Apri i prontofibra in lavorazione del BANDO 1" tooltipPosition="top" (click)="openPFInLavorazione(1)">In lavorazione: <span class="font-semibold" style="font-size: medium;">{{bando1InLavorazione}}</span></span>
      </div>
    </div>
    <button *ngIf="isPresidioSF || isDemo" pButton type="button" icon="pi pi-cloud-upload" pTooltip="Aggiorna i dati del prontofibra"
      tooltipPosition="top" class="font-['Poppins']"
      style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
      label="Carica file FIBERCOP" (click)="importaPF()" [disabled]="isLoading || isDemo">
    </button> 
  </div>
  <div class="col-12 grid mt-1 mb-1">
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #96ABC4; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">In attesa</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC;"
          (click)="openProntofibra(1,'IN ATTESA',null)" pTooltip="Apri prontofibra IN ATTESA del BANDO 1">hourglass_empty</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando1InAttesa}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 6" tooltipPosition="top" (click)="openProntofibra(1,'IN ATTESA',6)">LOTTO 6: <span
                class="text-l">{{bando1InAttesa_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 7" tooltipPosition="top" (click)="openProntofibra(1,'IN ATTESA',7)">LOTTO 7: <span
                class="text-l">{{bando1InAttesa_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #F59D5E; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">KO</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC;"
          (click)="openProntofibra(1,'KO',null)" pTooltip="Apri prontofibra KO del BANDO 1">link_off</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando1KO}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 6" tooltipPosition="top" (click)="openProntofibra(1,'KO',6)">LOTTO 6: <span
                class="text-l">{{bando1KO_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 7" tooltipPosition="top" (click)="openProntofibra(1,'KO',7)">LOTTO 7: <span
                class="text-l">{{bando1KO_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9 ; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">Pronti</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(1,'PRONTO',null)" pTooltip="Apri prontofibra PRONTI del BANDO 1">moving_ministry</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando1Pronte}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 6" tooltipPosition="top" (click)="openProntofibra(1,'PRONTO',6)">LOTTO 6: <span
                class="text-l">{{bando1Pronte_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 7" tooltipPosition="top" (click)="openProntofibra(1,'PRONTO',7)">LOTTO 7: <span
                class="text-l">{{bando1Pronte_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #ade8f4; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">Router Installato</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(1,'ROUTER INSTALLATO',null)" pTooltip="Apri prontofibra con ROUTER INSTALLATO del BANDO 1">cell_wifi</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando1RouterInstallato}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 6" tooltipPosition="top" (click)="openProntofibra(1,'ROUTER INSTALLATO',6)">LOTTO 6: <span
                class="text-l">{{bando1RouterInstallato_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 7" tooltipPosition="top" (click)="openProntofibra(1,'ROUTER INSTALLATO',7)">LOTTO 7: <span
                class="text-l">{{bando1RouterInstallato_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #D4F1DC; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;text-align: left;">Sede Attivata</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(1,'SEDE ATTIVATA',null)" pTooltip="Apri prontofibra con SEDE ATTIVATA del BANDO 1" tooltipPosition="top">verified</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando1Attivate}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.5rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 6" tooltipPosition="top" (click)="openProntofibra(1,'SEDE ATTIVATA',6)">LOTTO 6: <span
                class="text-l">{{bando1Attivate_lotto6}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 7" tooltipPosition="top" (click)="openProntofibra(1,'SEDE ATTIVATA',7)">LOTTO 7: <span
                class="text-l">{{bando1Attivate_lotto7}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    
  </div>
  <div class="col-12 border-bottom-1 opacity-50 "></div>

  <div class="col-12 mt-2 p-2 text-xl text-left font-['Poppins']"
    style="color: cornflowerblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <span class="text-xl text-left font-['Poppins'] mr-3" style="color: cornflowerblue;">Bando 2</span>
      <div class="p-2" style="border-radius: 10px; background-color: #619496; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #f9f9f9; font-size: small; cursor: pointer;"
              pTooltip="Apri tutti i prontofibra del BANDO 2" tooltipPosition="top" (click)="openAllPF(2)"
        >Totali: <span class="font-semibold" style="font-size: medium;">{{bando2}}</span></span>
      </div>
      <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;cursor: pointer;"
          pTooltip="Apri i prontofibra in lavorazione del BANDO 2" tooltipPosition="top" (click)="openPFInLavorazione(2)">In lavorazione: <span class="font-semibold" style="font-size: medium;">{{bando2InLavorazione}}</span></span>
      </div>
    </div>
    <button *ngIf="isPresidioSF || isDemo" pButton type="button" icon="pi pi-cloud-upload" pTooltip="Aggiorna i dati del prontofibra"
      tooltipPosition="top" class="font-['Poppins']"
      style="background-color:#ffffff; color: cornflowerblue; border-color: cadetblue; font-size: 13px;"
      label="Carica file FIBERCOP" (click)="importaPF()" [disabled]="isLoading || isDemo">
    </button> 
  </div>
  <div class="col-12 grid mt-1 mb-1">
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #96ABC4; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">In attesa</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC;"
          (click)="openProntofibra(2,'IN ATTESA',null)" pTooltip="Apri prontofibra IN ATTESA del BANDO 2">hourglass_empty</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando2InAttesa}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 1" tooltipPosition="top" (click)="openProntofibra(2,'IN ATTESA',1)">LOTTO 1: <span
                class="text-l">{{bando2InAttesa_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 5" tooltipPosition="top" (click)="openProntofibra(2,'IN ATTESA',5)">LOTTO 5: <span
                class="text-l">{{bando2InAttesa_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 7" tooltipPosition="top" (click)="openProntofibra(2,'IN ATTESA',7)">LOTTO 7: <span
                class="text-l">{{bando2InAttesa_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra IN ATTESA del lotto 8" tooltipPosition="top" (click)="openProntofibra(2,'IN ATTESA',8)">LOTTO 8: <span
                class="text-l">{{bando2InAttesa_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #F59D5E; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">KO</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC;"
          (click)="openProntofibra(2,'KO',null)" pTooltip="Apri prontofibra KO del BANDO 2">link_off</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando2KO}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 1" tooltipPosition="top" (click)="openProntofibra(2,'KO',1)">LOTTO 1: <span
                class="text-l">{{bando2KO_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 5" tooltipPosition="top" (click)="openProntofibra(2,'KO',5)">LOTTO 5: <span
                class="text-l">{{bando2KO_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 7" tooltipPosition="top" (click)="openProntofibra(2,'KO',7)">LOTTO 7: <span
                class="text-l">{{bando2KO_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ecd7b5', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra KO del lotto 8" tooltipPosition="top" (click)="openProntofibra(2,'KO',8)">LOTTO 8: <span
                class="text-l">{{bando2KO_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #DCEFF9 ; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">Pronti</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(2,'PRONTO',null)" pTooltip="Apri prontofibra PRONTI del BANDO 2">moving_ministry</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando2Pronte}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 1" tooltipPosition="top" (click)="openProntofibra(2,'PRONTO',1)">LOTTO 1: <span
                class="text-l">{{bando2Pronte_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 5" tooltipPosition="top" (click)="openProntofibra(2,'PRONTO',5)">LOTTO 5: <span
                class="text-l">{{bando2Pronte_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 7" tooltipPosition="top" (click)="openProntofibra(2,'PRONTO',7)">LOTTO 7: <span
                class="text-l">{{bando2Pronte_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra PRONTI del lotto 8" tooltipPosition="top" (click)="openProntofibra(2,'PRONTO',8)">LOTTO 8: <span
                class="text-l">{{bando2Pronte_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #ade8f4; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC; text-align: left;">Router Installato</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(2,'ROUTER INSTALLATO',null)" pTooltip="Apri prontofibra con ROUTER INSTALLATO del BANDO 2">cell_wifi</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando2RouterInstallato}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 1" tooltipPosition="top" (click)="openProntofibra(2,'ROUTER INSTALLATO',1)">LOTTO 1: <span
                class="text-l">{{bando2RouterInstallato_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 5" tooltipPosition="top" (click)="openProntofibra(2,'ROUTER INSTALLATO',5)">LOTTO 5: <span
                class="text-l">{{bando2RouterInstallato_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 7" tooltipPosition="top" (click)="openProntofibra(2,'ROUTER INSTALLATO',7)">LOTTO 7: <span
                class="text-l">{{bando2RouterInstallato_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con ROUTER INSTALLATO del lotto 8" tooltipPosition="top" (click)="openProntofibra(2,'ROUTER INSTALLATO',8)">LOTTO 8: <span
                class="text-l">{{bando2RouterInstallato_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="p-3" style="border-radius: 17px; background-color: #D4F1DC; text-align: right;">
        <div style="display: flex; justify-content: space-between; align-items: top;">
          <div class="font-semibold font-['Poppins']" style="color: #1C56AC;text-align: left;">Sede Attivata</div>
          <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #1C56AC"
            (click)="openProntofibra(2,'SEDE ATTIVATA',null)" pTooltip="Apri prontofibra con SEDE ATTIVATA del BANDO 2" tooltipPosition="top">verified</i>
        </div>
        <div class="text-3xl font-['Poppins'] mt-1" style="font-weight: bold; text-align: left; color: #1C56AC">{{bando2Attivate}}</div>
        <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 1" tooltipPosition="top" (click)="openProntofibra(2,'SEDE ATTIVATA',1)">LOTTO 1: <span
                class="text-l">{{bando2Attivate_lotto1}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC', 'margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 5" tooltipPosition="top" (click)="openProntofibra(2,'SEDE ATTIVATA',5)">LOTTO 5: <span
                class="text-l">{{bando2Attivate_lotto5}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC','margin-bottom': '0.2rem' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 7" tooltipPosition="top" (click)="openProntofibra(2,'SEDE ATTIVATA',7)">LOTTO 7: <span
                class="text-l">{{bando2Attivate_lotto7}}</span></div>
          </p-tag>
          <p-tag [style]="{ 'background': '#ddebf0', 'color':'#1C56AC' }">
            <div style="cursor: pointer;" pTooltip="Apri prontofibra con SEDE ATTIVATA del lotto 8" tooltipPosition="top" (click)="openProntofibra(2,'SEDE ATTIVATA',8)">LOTTO 8: <span
                class="text-l">{{bando2Attivate_lotto8}}</span></div>
          </p-tag>
        </div>
      </div>
    </div>
  </div>
</div>